<template>
  <div v-show="showTimer" :class="['countdown', { 'countdown--special': special }]">
    <template v-if="special">
      <div class="countdown__inner">
        <div class="countdown__el">
          <span v-for="(item, index) in splitHours" :key="index" class="countdown__singleNumber">
            {{ item }}
          </span>
        </div>
        <span class="countdown__separator">:</span>
        <div class="countdown__el">
          <span v-for="(item, index) in splitMinutes" :key="index" class="countdown__singleNumber">
            {{ item }}
          </span>
        </div>
        <span class="countdown__separator">:</span>
        <div class="countdown__el">
          <span v-for="(item, index) in splitSeconds" :key="index" class="countdown__singleNumber">
            {{ item }}
          </span>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="countdown__inner">
        <div class="countdown__el">
          {{ displayHours }}
          <span class="countdown__elUnit">{{ $t('hours') }}</span>
        </div>
        <div class="countdown__el">
          {{ displayMinutes }}
          <span class="countdown__elUnit">{{ $t('minutes') }}</span>
        </div>
        <div class="countdown__el">
          {{ displaySeconds }}
          <span class="countdown__elUnit">{{ $t('seconds') }}</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Countdown',
  props: {
    endDate: {
      type: Number,
      default: null,
    },
    special: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      timer: null,
      showTimer: false,
      displayHours: null,
      displayMinutes: null,
      displaySeconds: null,
    };
  },
  computed: {
    seconds: () => 1000,
    minutes() {
      return this.seconds * 60;
    },
    hours() {
      return this.minutes * 60;
    },
    end() {
      return new Date(this.endDate * 1000);
    },
    splitSeconds() {
      return this.displaySeconds ? this.displaySeconds.split('') : [];
    },
    splitMinutes() {
      return this.displayMinutes ? this.displayMinutes.split('') : [];
    },
    splitHours() {
      return this.displayHours ? this.displayHours.split('') : [];
    },
  },
  mounted() {
    this.showRemaining();
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    formatNum: num => (num < 10 ? '0' + num : '' + num),
    showRemaining() {
      this.timer = setInterval(() => {
        const now = new Date();
        const distance = this.end.getTime() - now.getTime();
        this.showTimer = true;
        if (distance < 0) {
          clearInterval(this.timer);
          this.showTimer = false;
        }
        const hours = Math.floor(distance / this.hours);
        const minutes = Math.floor((distance % this.hours) / this.minutes);
        const seconds = Math.floor((distance % this.minutes) / this.seconds);
        this.displayMinutes = this.formatNum(minutes);
        this.displaySeconds = this.formatNum(seconds);
        this.displayHours = this.formatNum(hours);
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
.countdown {
  $root: &;

  &__inner {
    display: flex;
  }

  &__el {
    margin-right: 3px;
  }

  &--special {
    font-size: 3.6rem;
    line-height: 4.5rem;
    color: $cMainDark;

    #{$root}__el {
      margin-right: 0;
    }

    #{$root}__separator {
      margin: 0 1rem;
    }

    #{$root}__singleNumber {
      margin-right: 0.5rem;
      display: inline-flex;

      &:last-of-type {
        margin-right: 0;
      }
    }
  }
}
</style>
